<template>
  <div id="app">
    <EniForMenu/>
    <transition >
      <router-view :key="$route.fullPath"/>
    </transition>
  </div>
</template>
<script>
import EniForMenu from "./components/EniForMenu";

export default {
  name: "App",
  components: {
    EniForMenu
  },
  beforeCreate() {
    this.$ml.change(process.env.VUE_APP_LANG);
  },
  watch: {
    $route(to) {
      this.$menuHub.$emit("close-menu");
    }
  }
};
</script>
<style lang="scss">
// GLOBAL
@import "./assets/scss/bootstrap-grid.scss";

:root {
  box-sizing: border-box;
}
*,
::before,
::after {
  box-sizing: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}
body {
  margin: 0;
}
#app {
  overflow: hidden;
}
a {
  text-decoration: none;
  user-select: none;
}
</style>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
</style>
